import {
    Button,
    Grid,
    ImageList,
    ImageListItem,
    InputLabel,
    TextField,
} from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import React, { useCallback, useEffect, useState } from "react";
import Admin from "components/Layouts/Admin";
import MyDropzone from "components/MyDropzone/MyDropzone";
import ValidationErrors from "components/ValidationErrors";
import { Link, useParams } from "react-router-dom";
import { getBlog, updateBlog } from "api/blogs";
import FetchDataWrapper from "components/FetchDataWrapper";
import { useNotification } from "contexts/NotificationContext";
import Editor from "components/Editor";

const Edit = () => {
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [formErrors, setFormErrors] = useState(null);

    const { notification } = useNotification();

    const [blog, setblog] = useState();
    const { slug } = useParams();

    const [data, setData] = useState({
        title: "",
        thumbnail: null,
        details: "",
    });

    const handleChange = (event) => {
        setData((prev) => ({
            ...prev,
            [event.target.name]: event.target.value,
        }));
    };

    const handleSubmit = () => {
        setFormLoading(true);
        setFormErrors(null);

        const formData = new FormData();
        formData.append("title", data.title);
        formData.append("details", data.details);
        if (data.thumbnail) {
            formData.append("thumbnail", data.thumbnail, data.thumbnail?.name);
        }

        updateBlog(blog?.slug, formData)
            .then((response) => {
                setblog(response.data.data);
                notification.success("Blog updated successfully");
            })
            .catch((_errors) => {
                notification.failed("Failed to update blog");
                setFormErrors(_errors.response.data);
            })
            .finally(() => setFormLoading(false));
    };

    const handleThumbnailDrop = (files) => {
        setData((prevState) => ({ ...prevState, thumbnail: files[0] }));
    };

    const handleThumbnailRemove = () =>
        setData((prevState) => ({ ...prevState, thumbnail: null }));

    const handleGetBlog = useCallback(() => {
        setLoading(true);
        setErrors(null);

        getBlog(slug)
            .then((response) => {
                const _blog = response.data.data;
                setblog(_blog);
                setData((prev) => ({
                    ...prev,
                    title: _blog.title,
                    details: _blog.details,
                }));
            })
            .catch((_errors) => setErrors(_errors.response.data))
            .finally(() => setLoading(false));
    }, [slug]);

    useEffect(() => {
        handleGetBlog();
    }, [handleGetBlog]);

    const actions = (
        <Link to={"/blogs"}>
            <Button
                variant="contained"
                size="small"
                startIcon={<ArrowBackIcon />}
            >
                Back
            </Button>
        </Link>
    );

    return (
        <Admin sectionTitle="Edit blog" selected={"Blogs"} actions={actions}>
            <FetchDataWrapper
                loading={loading}
                errors={errors}
                data={blog}
                renderData={(blog) => (
                    <Grid container columnSpacing={2}>
                        <Grid item xs={12} md={8} order={{ xs: 2, md: 1 }}>
                            <>
                                <TextField
                                    type={"text"}
                                    name="title"
                                    label="Title"
                                    defaultValue={blog?.title}
                                    onChange={handleChange}
                                    sx={{
                                        marginY: 2,
                                        width: "100%",
                                    }}
                                />

                                <Editor
                                    placeholder={"Details"}
                                    defaultValue={data?.details}
                                    onChange={(value) =>
                                        setData((prev) => ({
                                            ...prev,
                                            details: value,
                                        }))
                                    }
                                    className="ql-description"
                                />

                                <InputLabel sx={{ marginY: 2 }}>
                                    {" "}
                                    Thumbnail{" "}
                                </InputLabel>
                                <MyDropzone
                                    title="Drag thumbnail here"
                                    subTitle="Only *.jpeg, *.jpg and *.png images will be accepted"
                                    maxFilesCount={1}
                                    acceptableTypes={{
                                        "image/png": [],
                                        "image/jpeg": [],
                                    }}
                                    defaultFiles={[data.thumbnail]}
                                    handleDrop={handleThumbnailDrop}
                                    handleRemove={handleThumbnailRemove}
                                />
                                <ImageList
                                    sx={{ maxWidth: 500, maxHeight: 450 }}
                                >
                                    <ImageListItem>
                                        <img
                                            src={`${blog?.thumbnail}`}
                                            alt=""
                                        />
                                    </ImageListItem>
                                </ImageList>

                                <Button
                                    type="button"
                                    size="small"
                                    variant="contained"
                                    disabled={formLoading}
                                    sx={{ display: "block", marginY: 2 }}
                                    onClick={handleSubmit}
                                >
                                    Save Changes
                                </Button>
                            </>
                        </Grid>
                        <Grid item xs={12} md={4} order={{ xs: 1, md: 2 }}>
                            <ValidationErrors errors={formErrors} />
                        </Grid>
                    </Grid>
                )}
            />
        </Admin>
    );
};

export default Edit;
